import { pages, subPackages, tabBar } from '@/pages.json'
import { isMpWeixin } from './platform'
import { ClearStorage } from './uniVab'

const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包会报错，所以改用下面这个【虽然我加了 src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/** 判断当前页面是否是 tabbar 页  */
export const getIsTabbar = () => {
  if (!tabBar) {
    return false
  }
  if (!tabBar.list.length) {
    // 通常有 tabBar 的话，list 不能有空，且至少有2个元素，这里其实不用处理
    return false
  }
  const lastPage = getLastPage()
  const currPath = lastPage.route
  return !!tabBar.list.find((e) => e.pagePath === currPath)
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 '/pages/login/index'
 * redirectPath 如 '/pages/demo/base/route-interceptor'
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // console.log('lastPage.$page:', currRoute)
  // console.log('lastPage.$page.fullpath:', currRoute.fullPath)
  // console.log('lastPage.$page.options:', currRoute.options)
  // console.log('lastPage.options:', (lastPage as any).options)
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

const ensureDecodeURIComponent = (url: string) => {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export const getUrlObj = (url: string) => {
  const [path, queryStr] = url.split('?')
  // console.log(path, queryStr)

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    // console.log(key, value)
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 这里设计得通用一点，可以传递 key 作为判断依据，默认是 needLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的 pages，如果传递了 key, 则表示通过 key 过滤
 */
export const getAllPages = (key = 'needLogin') => {
  const mainPages = [
    ...pages

      .filter((page) => !key || page[key])
      .map((page) => ({
        ...page,
        path: `/${page.path}`,
      })),
  ]
  // 这里处理分包
  const subPages: any[] = []
  subPackages.forEach((subPageObj) => {
    const { root } = subPageObj

    subPageObj.pages
      .filter((page) => !key || page[key])
      .forEach((page: { path: string } & Record<string, any>) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  return result
}

/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的需要登录的 pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages: string[] = getAllPages('needLogin').map((page) => page.path)

/**
 * @description         图片缩略图
 * @param img {String}  图片链接地址
 * @param w {Number}    宽
 * @param h {Number}    高
 * @param q {Number}    清晰度
 * @returns {string}
 */
export function lazyImg(img: string, w = 200, h = 200, q = 65): string {
  if (!img) return ''
  if (
    img.includes(import.meta.env.VITE_APP_ASSETS_URL) ||
    img.includes(import.meta.env.VITE_APP_OSS_URL)
  ) {
    img = img.replace(import.meta.env.VITE_APP_OSS_URL, import.meta.env.VITE_APP_ASSETS_URL)
  }
  // svg不支持压缩
  if (img.includes('.svg')) return img
  if (img.includes(`${import.meta.env.VITE_APP_ASSETS_URL}`)) {
    return `${img}?x-oss-process=image/resize,w_${w},h_${h},limit_0/quality,q_${q}`
  }
  // 使用于七牛
  return `${img}?imageView2/2/w/${w}/h/${h}/q/${q}`
}

// 图片预览
export function PreviewImage({ current = 0, indicator = 'number', urls = [] } = {}) {
  uni.previewImage({
    current,
    indicator: indicator as 'number' | 'default' | 'none',
    urls,
  })
}

// 传入一个value , numKey, strKey 返回一个对象
export function getFilterKey(config: any) {
  const { value, numKey, strKey } = config
  const valueArray = value.split('-')
  const object = {} as any
  if (isNaN(value) && valueArray.length === 1) {
    object[numKey] = ''
    object[strKey] = value
  } else {
    object[numKey] = value
    object[strKey] = ''
  }
  return object
}

// 清除缓存，是应用登录失效，退出登录，清空缓存
// 这样写的原因 是因为 在小程序中不会刷新整个页面， 所以部分情况下还存在相对应的数据
export function ClearCache() {
  ClearStorage(true)
  // useUserStore().emptyStore()
  // useAppStore().emptyStore()
}

// 提取视频第一帧
export function getVideoCover(url: string) {
  if (isAliyun(url)) {
    return `${url}?x-oss-process=video/snapshot,t_0,f_png,m_fast`
  } else {
    return `${url}?vframe/jpg/offset/1/w/640/h/360`
  }
}

// 判断是不是阿里云图片或者视频
export function isAliyun(url: string) {
  const list = ['abk-web.oss-cn', 'assets.anbangke.com']
  return list.some((item) => url.indexOf(item) > -1)
}
